import { Link } from 'react-router-dom';
import { useSeo } from '../utils/seo';

// Catch-all for any URL that doesn't match a route — a renamed/removed tool,
// a typo, a stale external link. Firebase Hosting's SPA rewrite serves this
// (as HTTP 200, since a static host can't return a real 404 for a client-side
// route) for every unmatched path, so without this route those visits landed
// on a blank page. `noindex` keeps a soft-404 like this out of search results
// while still sending the visitor somewhere useful.
export default function NotFound() {
  useSeo({
    title: 'Page not found | LE Tech Tools',
    description: 'This page does not exist or has moved.',
    noindex: true,
  });

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8fafc',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      color: '#0f172a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{ fontSize: 44, marginBottom: 12 }}>🔍</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 8px' }}>Page not found</h1>
        <p style={{ color: '#64748b', fontSize: 14.5, lineHeight: 1.6, margin: '0 0 24px' }}>
          This page doesn&rsquo;t exist, or the tool has moved. If you followed a link to get here,
          it may be out of date.
        </p>
        <Link
          to="/tools"
          style={{
            display: 'inline-block', background: '#4f46e5', color: '#fff',
            textDecoration: 'none', padding: '10px 22px', borderRadius: 8,
            fontSize: 14, fontWeight: 700,
          }}
        >
          Browse all tools
        </Link>
      </div>
    </div>
  );
}
